<template>
  <div class="section aside-detail">
    <div class="user-detail">
      <div class="columns is-multiline is-mobile">
        <div class="column is-12 info">
          <label class="title-menu">Perfil</label>
          <ul>
            <li>
              <router-link class="link" to="/profile/me">Mi perfil</router-link>
            </li>
          </ul>
          <hr>
          <label class="title-menu">Empresa</label>
          <ul>
            <li>
              <router-link class="link" to="/profile/company">Perfil</router-link>
            </li>
            <li v-if="enableMenu">
              <router-link
                class="link"
                :class="{ 'router-link-exact-active router-link-active': isUsersRoute }"
                to="/profile/menu"
              >
                Usuarios
              </router-link>
            </li>
            <!-- <li v-if="['admin', 'developer', 'compliance'].includes(role)">
              <router-link class="link" to="/profile/api">API</router-link>
            </li> -->
          </ul>
          <hr>
          <label class="title-menu">Personalización</label>
          <ul>
            <li v-if="['admin', 'developer'].includes(role)">
              <router-link class="link" to="/profile/website">Portal web</router-link>
            </li>
            <li v-if="hasSubmoduleMyAccountPermission('emails') && ['admin', 'developer', 'manager', 'compliance'].includes(role)">
              <router-link class="link" to="/profile/mails">Emails</router-link>
            </li>
            <!--<li v-if="['admin', 'developer', 'manager', 'compliance'].includes(role)">
              <router-link class="link" to="/profile/cms">Contenido Web</router-link>
            </li>
            <li v-if="['admin', 'developer', 'manager', 'compliance'].includes(role.code)">
              <router-link class="link" to="/profile/documents">Documentos contractuales</router-link>
            </li>
            <li v-if="['admin', 'developer'].includes(role)">
              <router-link class="link" to="/profile/integrations">Integraciones API</router-link>
            </li>
            <li v-if="role === 'admin'">
              <router-link class="link" to="/profile/certs">Certificados</router-link>
            </li>-->
          </ul>
          <template v-if="hasTicketsModule">
            <hr>
            <label class="title-menu">Soporte</label>
            <ul>
              <li>
                <router-link class="link" to="/profile/tickets">Tickets</router-link>
              </li>
            </ul>
          </template>
          <!--<hr>
          <label class="title-menu">Configuración</label>
          <ul>
            <li v-if="['admin', 'developer', 'manager'].includes(role)">
              <router-link class="link" to="/profile/webhooks">Webhooks</router-link>
            </li>
          </ul> -->
          <!-- <hr>
          <label class="title-menu">Recursos</label>
          <ul>
            <li>
              <router-link class="link" to="/profile/trainings">Capacitaciones</router-link>
            </li>
          </ul> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import mixins from '@/mixins/formats'

export default {
  name: 'Detail',
  components: {},
  props: {
    customer: {
      type: Object
    },
    loading: {
      type: Boolean,
      default: true
    },
    linkReturn: {
      type: Function,
      default: () => '/'
    }
  },
  mixins: [mixins],
  data () {
    return {
      miniMenu: false,
      modalResendEmailActivation: false,
      hasAccess: false
    }
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration,
      financialCompany: state => state.financialCompany.financialCompany,
      role: state => state.financialCompany?.role?.code || '',
      enabledFinancialModules: state => state.enabledFinancialModules.modules
    }),
    hasTicketsModule () {
      return this.enabledFinancialModules.some(module => module.code === 'tickets')
    },
    isCmsRoute () {
      return this.$route.path.startsWith('/profile/cms')
    },
    isUsersRoute () {
      return this.$route.path.startsWith('/profile/menu')
    },
    enableMenu () {
      const adminRoles = ['admin', 'manager', 'compliance']
      return adminRoles.includes(this.role) || this.hasAccess
    }
  },
  watch: {
    role (newValue) {
      if (newValue === 'custom') {
        this.hasCustomRoleAccess()
      }
    }
  },
  mounted () {
    if (this.role === 'custom') {
      this.hasCustomRoleAccess()
    }
    // No se dispara getFinancialModules aquí: el router guard (src/router/index.js)
    // ya lo carga una sola vez al entrar, antes de que cualquier vista se monte.
  },
  methods: {
    ...mapActions(['getServicePermission']),
    async hasCustomRoleAccess () {
      const requiredPermissions = ['Roles', 'Users', 'saveUser', 'Brokers', 'saveBroker']
      const resp = await this.getServicePermission(requiredPermissions)
      const filter = resp.filter(service => service.enabled).map(service => service.code)
      this.hasAccess = requiredPermissions.some(el => filter.includes(el))
    },
    hasSubmoduleMyAccountPermission (permission) {
      const myAccountModule = this.enabledFinancialModules.find(module => module.code === 'my_account')
      if (!myAccountModule || !myAccountModule.permissions) {
        return false
      }
      return myAccountModule.permissions.some(perm => perm.code === permission)
    }
  }
}
</script>
